import React from "react";
import "./index.scss"
import { CloseIcon } from "../../icons/options"
import jt2 from "../../assets/jt2.png";
import animateCss from "../../utils";
import { Link } from "react-router-dom";


class ExtMenu extends React.Component {
    close() {
        this.props.extRef.current.classList.remove("animate__slideInDown")
        animateCss(this.props.extRef.current, "slideOutUp")
        .then(() => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop < 490) {
                this.props.topBarRef.current.classList.remove("visible")
            }
            this.props.closeExt({isExt: false})
        })
    }

    render() {
        return <div className="ext-menu animate__animated animate__slideInDown" ref={this.props.extRef} onMouseLeave={()=>this.close()}>
            <div className="ext-container">
                <ul className="project-left" onClick={()=>{
                    if (document.getElementsByClassName("project-part-2")[0]) {
                        document.getElementsByClassName("project-part-2")[0].scrollIntoView()
                    }
                }}>
                    <li><Link to={{ pathname: "/project-pipe", state: { activeSlide: 1, goToBar: true } }}>多模态脑影像管理计算分析</Link></li>
                    <li><img src={jt2}/><Link to={{ pathname: "/project-pipe", state: { activeSlide: 1, goToBar: true } }}>多模态脑影像数据管理计算分析平台</Link></li>
                    <li><img src={jt2}/><Link to={{ pathname: "/project-pipe", state: { activeSlide: 2, goToBar: true } }}>多模态脑影像数据质控与管理系统</Link></li>
                    <li><img src={jt2}/><Link to={{ pathname: "/project-pipe", state: { activeSlide: 3, goToBar: true } }}>数据管理计算分析平台</Link></li>
                </ul>
                <ul className="project-right">
                    <li><Link to={{ pathname: "/project-pipe", state: { activeSlide: 4, goToBar: true } }}>癫痫致痫灶无创精准定位</Link></li>
                    <li><img src={jt2}/><Link to={{ pathname: "/project-pipe", state: { activeSlide: 4, goToBar: true } }}>癫痫致痫灶精准定位系统</Link></li>
                    <li><img src={jt2}/><Link to={{ pathname: "/project-pipe", state: { activeSlide: 5, goToBar: true } }}>临床癫痫多模态数据库平台</Link></li>
                </ul>
            </div>
            <div className="menu-bg"></div>
        </div>
    }
}

export default ExtMenu;
